import React, { useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'syngenta-digital-cropwise-react-ui-kit';
import { NavItem } from '@agconnections/grow-ui';
import { useLocation, NavLink } from 'react-router-dom';
import { startCase } from 'lodash';

import { Context } from 'components/Store';
import { paths } from 'routes/paths';
import { AmplitudeContext } from 'utilities/amplitude/useAmplitude';

const BaseNavItem = ({ item, isOpened }) => {
  const location = useLocation();
  const amplitude = useContext(AmplitudeContext);
  const [{ organization }] = useContext(Context);

  const [isHovered, setIsHovered] = useState(false);
  const isActive =
    location.pathname.includes(item.path) ||
    (location.pathname.includes(paths.organizations) &&
      item.id === 'organization');

  const ConditionalTooltip = useCallback(
    ({ children, title }) =>
      isOpened ? (
        children
      ) : (
        <Tooltip placement="right" title={title} color="#232630">
          <div className="w-full h-full flex flex-col justify-center items-center">
            {children}
          </div>
        </Tooltip>
      ),
    [isOpened]
  );

  const NavIcon = item.icon;

  return (
    <NavItem
      key={item.key}
      disabled={item.disabled}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      icon={
        <ConditionalTooltip title={startCase(item.id)}>
          <NavIcon
            className="transition duration-100 ease-in-out"
            fill={isHovered || isActive ? 'white' : '#696F88'}
          />
        </ConditionalTooltip>
      }
      open={isOpened}
      active={isActive}
      as={
        <NavLink
          key={item.key}
          onClick={() =>
            amplitude.sendEventToAmplitude(amplitude.filterNavItems(item.key))
          }
          to={
            item.key === 'organizations'
              ? `${paths.organizations}/${organization.id}`
              : item.path
          }
          exact
        />
      }
    >
      {startCase(item.id)}
    </NavItem>
  );
};

BaseNavItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    key: PropTypes.string,
    path: PropTypes.string,
    icon: PropTypes.elementType,
    disabled: PropTypes.bool
  }).isRequired,
  isOpened: PropTypes.bool.isRequired
};

export default BaseNavItem;
